module.exports = function getResource (label) {
    let resources = {
        default: 'Default'
    };

    return resources[label];
};
